var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "fieldset",
    { staticClass: "custom-fieldset" },
    [
      _c("legend", [_vm._v("Pojazd nr " + _vm._s(_vm.partIndex + 1))]),
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { staticClass: "pa-1", attrs: { md: "4", cols: "12" } },
            [
              _c("v-text-field", {
                attrs: {
                  rules: [_vm.isRequired],
                  label: "Wypożyczalnia*",
                  readonly: _vm.$store.state.AdminTravelService.isOfferReadonly
                },
                model: {
                  value: _vm.contextPart.name,
                  callback: function($$v) {
                    _vm.$set(_vm.contextPart, "name", $$v)
                  },
                  expression: "contextPart.name"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "pa-1", attrs: { md: "4", cols: "12" } },
            [
              _c("v-text-field", {
                attrs: {
                  rules: [_vm.isRequired],
                  label: "Termin odbioru*",
                  readonly: _vm.$store.state.AdminTravelService.isOfferReadonly
                },
                model: {
                  value: _vm.contextPart.start_date,
                  callback: function($$v) {
                    _vm.$set(_vm.contextPart, "start_date", $$v)
                  },
                  expression: "contextPart.start_date"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "pa-1", attrs: { md: "4", cols: "12" } },
            [
              _c("v-text-field", {
                attrs: {
                  rules: [_vm.isRequired],
                  label: "Termin zwrotu*",
                  readonly: _vm.$store.state.AdminTravelService.isOfferReadonly
                },
                model: {
                  value: _vm.contextPart.end_date,
                  callback: function($$v) {
                    _vm.$set(_vm.contextPart, "end_date", $$v)
                  },
                  expression: "contextPart.end_date"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "pa-1", attrs: { md: "4", cols: "12" } },
            [
              _c("v-text-field", {
                attrs: {
                  rules: [_vm.isRequired],
                  label: "Typ pojazdu*",
                  readonly: _vm.$store.state.AdminTravelService.isOfferReadonly
                },
                model: {
                  value: _vm.contextPart.car_class,
                  callback: function($$v) {
                    _vm.$set(_vm.contextPart, "car_class", $$v)
                  },
                  expression: "contextPart.car_class"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "pa-1", attrs: { md: "4", cols: "12" } },
            [
              _c("v-text-field", {
                attrs: {
                  rules: [_vm.isRequired],
                  label: "Miejsce odbioru*",
                  readonly: _vm.$store.state.AdminTravelService.isOfferReadonly
                },
                model: {
                  value: _vm.contextPart.from,
                  callback: function($$v) {
                    _vm.$set(_vm.contextPart, "from", $$v)
                  },
                  expression: "contextPart.from"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "pa-1", attrs: { md: "4", cols: "12" } },
            [
              _c("v-text-field", {
                attrs: {
                  rules: [_vm.isRequired],
                  label: "Miejsce zwrotu*",
                  readonly: _vm.$store.state.AdminTravelService.isOfferReadonly
                },
                model: {
                  value: _vm.contextPart.to,
                  callback: function($$v) {
                    _vm.$set(_vm.contextPart, "to", $$v)
                  },
                  expression: "contextPart.to"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "pa-1", attrs: { md: "4", cols: "12" } },
            [
              _c("v-text-field", {
                attrs: {
                  rules: [_vm.isRequired],
                  label: "Cena za dzień*",
                  readonly: _vm.$store.state.AdminTravelService.isOfferReadonly
                },
                model: {
                  value: _vm.contextPart.price_per_day,
                  callback: function($$v) {
                    _vm.$set(_vm.contextPart, "price_per_day", $$v)
                  },
                  expression: "contextPart.price_per_day"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "pa-1", attrs: { cols: "12" } },
            [
              _c("v-textarea", {
                attrs: {
                  label: "Komentarz",
                  readonly: _vm.$store.state.AdminTravelService.isOfferReadonly
                },
                model: {
                  value: _vm.contextPart.comment,
                  callback: function($$v) {
                    _vm.$set(_vm.contextPart, "comment", $$v)
                  },
                  expression: "contextPart.comment"
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }